import React from 'react';
import StartConsultationCard from './StartConsultationCard';

type Card = {
	step: string | number;
	title: string;
	content: string;
	imgSrc: string;
	imgAlt: string;
};

type Props = {
	cards: Card[];
};

export const StartConsultationCardContainerDesktop: React.FC<Props> = ({ cards }) => {
	return (
		<div 
			id="cards-container-desktop" 
			className="
				w-full
				flex 
				flex-row 
				justify-center 
				items-center 
				px-2 
				md:px-10 
				gap-[20px] 
				p-2 
				mt-4
				pb-20
			"
		>
			{cards?.map((card, index) => (
				<StartConsultationCard 
					key={index} 
					step={card.step} 
					title={card.title} 
					content={card.content} 
					imgSrc={card.imgSrc} 
					imgAlt={card.imgAlt}
					isLast={index === cards.length - 1}
				/>
			))}
		</div>
	);
};

export default StartConsultationCardContainerDesktop;
